// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkButton_link__1UPRw","block":"LinkButton_block__3N5Jh","noDecoration":"LinkButton_noDecoration__vHyBT","disabledLink":"LinkButton_disabledLink__1IsW1"};